import React from 'react';
import ProductFeatureComponent from '../@shared/productFeatureComponent';
import { TProductFeatureComponentProps } from '../@shared/productFeatureComponent/types/productFeatureComponent.types';
import AnalyticsVisibleEvent from '../@shared/analyticsVisibleEvent';
import { modelFeaturesCTAOpen, modelFeaturesVisible } from '../../constants/analytics.constants';
import { titleKeyModelFeatures } from '../../constants/dictionary.constants';

const ProductModelDetailFeature = (props: TProductFeatureComponentProps) => {
  return (
    <AnalyticsVisibleEvent event={modelFeaturesVisible}>
      <ProductFeatureComponent
        {...props}
        showImageOverlay={true}
        cardCTAVisibleEvent={modelFeaturesCTAOpen}
        titleDictionaryKeyFeature={titleKeyModelFeatures}
      />
    </AnalyticsVisibleEvent>
  );
};

export default ProductModelDetailFeature;
